export const getFromStorage = (storageKey: string, storage: Storage): unknown => {
    const data = storage.getItem(storageKey);

    if (!data) return null;

    try {
        return JSON.parse(data);
    } catch (e) {
        console.error(e);
        // битый JSON удаляем, иначе ключ залипает на все будущие запуски
        storage.removeItem(storageKey);
    }

    return null;
};
